export default "https://statics.cloudfastin.top/static/v1.27.18.3/store/images/sharing.png?ecde7c097564a29d46e990d405e548ac";